module.exports = __webpack_public_path__ + "img/2.73f8f7a7.jpg";